import clsx from "clsx"
import globalMU from "globalMU"
import React from "react"
import { ordenarTiposFrete } from "./funcoes"
import { DadosFreteProduto } from "./tipos"
const estilosTabela = require('app/estilos/tabelas.module.scss').default
const estilosInputs = require('app/estilos/inputs.module.scss').default
const estilosFretePorPesoCubagem = require('./fretePorPesoCubagem.module.scss').default
import * as R from 'ramda'
import { format } from "date-fns"
import { DataFormatoEN } from "app/types/DataFormatoEN"
import { chaveEhDeFreteEspecial, obterChaveSelecaoTipoFrete, obterChaveSelecaoTipoFretePelosDadosProduto, obterIdTipoFreteSelecionado } from "./funcoesTiposFrete"
import { InputData } from "../inputs/InputData"

export type ItemDadosFreteProdutoProps = {
    somenteLeitura: boolean
    dadosFreteProduto: DadosFreteProduto
    numeroCasasDecimaisQuantidade: number
    permitirSelecaoDeTipoDeFretePorItem: boolean
    exibirSomenteFreteEspecialSeHouver: boolean
    onTipoDeFreteModificado: (idTipoFrete: number, ehFreteEspecial: boolean) => void
    onDataPrevistaAlterada: (novaData: DataFormatoEN) => void
}

export const ItemDadosFreteProduto = (props: ItemDadosFreteProdutoProps) => {


    const selectTipoFrete = <>
        <select className={estilosInputs.select}
            disabled={props.somenteLeitura}
            value={(obterChaveSelecaoTipoFretePelosDadosProduto(props.dadosFreteProduto)) ?? ""}
            onChange={e => props.onTipoDeFreteModificado(obterIdTipoFreteSelecionado(e.target.value), chaveEhDeFreteEspecial(e.target.value))}>

            <option value=""></option>

            {R.sort(ordenarTiposFrete, props.dadosFreteProduto.tiposFrete ?? [])
                .filter(tipoFrete => (tipoFrete.Id == props.dadosFreteProduto.idTipoFrete && tipoFrete.EhFreteEspecial == props.dadosFreteProduto.ehFreteEspecial) || (props.exibirSomenteFreteEspecialSeHouver ? tipoFrete.EhFreteEspecial : true))
                .map(tipoFrete =>
                    <option
                        key={obterChaveSelecaoTipoFrete(tipoFrete)}
                        value={obterChaveSelecaoTipoFrete(tipoFrete)}>
                        {tipoFrete.Descricao}
                    </option>)}
        </select>
    </>

    const obterDescricaoTipoFreteAtualDoProduto = () => {
        const tipoFreteAtualProduto = (props.dadosFreteProduto.tiposFrete ?? [])
            .find(tf => tf.Id == props.dadosFreteProduto.idTipoFrete && tf.EhFreteEspecial == props.dadosFreteProduto.ehFreteEspecial)

        return tipoFreteAtualProduto == null ? "" : `${tipoFreteAtualProduto.Descricao}`
    }

    const labelTipoFrete = <>
        <span>
            {obterDescricaoTipoFreteAtualDoProduto()}
        </span>
    </>

    const aplicarClasseFaixaPesoOuCubagemNaoLocalizadaOuFreteNaoPermitidoParaProduto = () => {
        return props.dadosFreteProduto.descricaoInconsistenciaFrete == "FAIXA_NAO_ENCONTRADA" ||
            props.dadosFreteProduto.descricaoInconsistenciaFrete == "TIPO_FRETE_NAO_PERMITIDO_PARA_PRODUTO"
    }

    const aplicarClasseInconsistencia = () => {
        return props.dadosFreteProduto.descricaoInconsistenciaFrete == "PESO_NAO_INFORMADO_PARA_PRODUTO" ||
            props.dadosFreteProduto.descricaoInconsistenciaFrete == "METODO_DE_CALCULO_NAO_CONFIGURADO_PARA_PRODUTO" ||
            props.dadosFreteProduto.descricaoInconsistenciaFrete == "VOLUME_NAO_INFORMADO_PARA_PRODUTO"
    }

    const possuiFreteEspecial = () => (props.dadosFreteProduto.tiposFrete ?? []).some(tf => tf.EhFreteEspecial)

    const possuiMaisDeUmFrete = () => (props.dadosFreteProduto.tiposFrete ?? []).length > 1

    const exibirSeletorDeTipoDeFrete = () => {

        const existeAlgumFreteEspecialDisponivel = () => (props.dadosFreteProduto.tiposFrete ?? []).some(tf => tf.EhFreteEspecial)

        return props.permitirSelecaoDeTipoDeFretePorItem || (existeAlgumFreteEspecialDisponivel() && props.exibirSomenteFreteEspecialSeHouver)

    }

    return <>
        <tr className={clsx(
            possuiFreteEspecial() ? estilosFretePorPesoCubagem.freteEspecialLocalizado : '',
            !possuiFreteEspecial() && possuiMaisDeUmFrete() ? estilosFretePorPesoCubagem.produtoComMaisDeUmFrete : '',
            aplicarClasseInconsistencia() ? estilosFretePorPesoCubagem.inconsistencia : '',
            aplicarClasseFaixaPesoOuCubagemNaoLocalizadaOuFreteNaoPermitidoParaProduto() ? estilosFretePorPesoCubagem.faixaPesoOuCubagemNaoLocalizadaOuFreteNaoPermitidoParaProduto : '')}
            id={`ItemDadosFreteProduto_Linha_${props.dadosFreteProduto.identificadorItem}`}
            key={props.dadosFreteProduto.identificadorItem}
        >
            <td
                id={`ItemDadosFreteProduto_CodigoOuReferencia_${props.dadosFreteProduto.identificadorItem}`}
            >
                {props.dadosFreteProduto.codigoOuReferencia}
            </td>
            <td
                id={`ItemDadosFreteProduto_Descricao_${props.dadosFreteProduto.identificadorItem}`}
            >
                {props.dadosFreteProduto.descricao}
            </td>
            <td className={estilosTabela.dadoNumerico}
                id={`ItemDadosFreteProduto_Quantidade_${props.dadosFreteProduto.identificadorItem}`}
            >
                {globalMU.formatarValorNumerico(props.dadosFreteProduto.quantidade, props.numeroCasasDecimaisQuantidade, false)}
            </td>
            <td
                id={`ItemDadosFreteProduto_TipoFrete_${props.dadosFreteProduto.identificadorItem}`}
            >
                {!props.somenteLeitura && exibirSeletorDeTipoDeFrete() ? selectTipoFrete : labelTipoFrete}
            </td>
            <td
                id={`ItemDadosFreteProduto_DataPrevista_${props.dadosFreteProduto.identificadorItem}`}
            >
                {props.dadosFreteProduto.dataPrevista == null ? '' :
                    <InputData
                        id={`ItemDadosFreteProduto_DataPrevista_Input_${props.dadosFreteProduto.identificadorItem}`}
                        disabled={props.somenteLeitura}
                        data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(props.dadosFreteProduto.dataPrevista)}
                        bloquearDataMenorQueHoje={true}
                        onChange={(e) => props.onDataPrevistaAlterada(e)}
                        selecionaValorOnFocus
                    />
                }

            </td>
        </tr>
    </>
}